import keyBy from 'lodash/keyBy';

export default siteScopes => {
  const scopesByScopeId = keyBy(siteScopes, 'scopeId');

  return (
    siteScopes.find(siteScope => {
      return !siteScope.parentScopeId;
    }) ||
    siteScopes.find(siteScope => {
      return !scopesByScopeId[siteScope.parentScopeId];
    }) ||
    siteScopes[0]
  );
};
